import { render } from "./MenuPage.vue?vue&type=template&id=0fff8438"
import script from "./MenuPage.vue?vue&type=script&lang=js"
export * from "./MenuPage.vue?vue&type=script&lang=js"

import "./MenuPage.vue?vue&type=style&index=0&id=0fff8438&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__